import React, { useEffect, useState } from "react";
import { Box, Button } from "@chakra-ui/react";
import PriceListsTable from "./PriceListsTable";
import PriceListsFilter from "./PriceListsFilter";
import ContentCard from "../Common/Layout/ContentCard";
import { useHistory } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import Body from "../Common/Body";

const PriceLists = () => {
  const history = useHistory();
  const [priceLists, setPriceLists] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { get } = useFetch();

  useEffect(() => {
    getPriceLists();
  }, []);

  const getPriceLists = async (queries = {}) => {
    setIsLoading(true);

    let url = "/priceLists?";

    Object.keys(queries).map(function (key, index) {
      url += key + "=" + queries[key] + "&";
    });

    get(url)
      .then(async (res) => {
        setPriceLists(res);
      })
      .catch((e) => {
        console.log(e);
        throw new Error(e);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      <Body title={"Lista de precios"} isLoading={isLoading}>
        <ContentCard>
          <PriceListsFilter getPriceLists={getPriceLists}></PriceListsFilter>
        </ContentCard>
        <Box>
          <ContentCard>
            <Button
              my="2"
              colorScheme="blue"
              onClick={() => history.push("/lista-de-precios/new")}
            >
              + Lista de precios
            </Button>
            <PriceListsTable
              getPriceLists={getPriceLists}
              priceLists={priceLists}
            ></PriceListsTable>
          </ContentCard>
        </Box>
      </Body>
    </>
  );
};

export default PriceLists;
